import {combineReducers} from 'redux';
import users from './myuser.reducer';

const myUsersStore = combineReducers({
    users
});

export default myUsersStore;